import { Component, input } from '@angular/core';
import { IonSpinner } from '@ionic/angular/standalone';
import { CONSTANTS } from './loading-modal.constants';

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.scss'],
  imports: [IonSpinner],
})
export class LoadingModalComponent {
  readonly loadingText = input(CONSTANTS.LOADING);
}
